<template>
  <pt-branch-company class="pt-branch-company__page"></pt-branch-company>
</template>

<script>
import PtBranchCompany from 'cps//branch-company-manage//pt-branch-company/withData'
export default {
  name: 'pt-branch-company__view',
  components: {
    'pt-branch-company': PtBranchCompany
  }
}
</script>
